import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FormLabel } from '@/components/v4';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

/**
 * Template ID field. Editable in add mode, but the API rejects a PUT that
 * changes the ID (400 "Invalid AATemplate"), so it's read-only once editing
 * an existing template — matching the "(read-only)" label + gray-text input
 * style used by TRSClusterRegionField/TRSClusterDescriptionField.
 */
const TemplateIdField = ({ darkMode, errors, touched, isEditMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired={!isEditMode}
            isInvalid={!!errors.id && touched.id}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    ID{' '}
                    {isEditMode && (
                        <span className="font-medium text-gray-400">
                            (read-only)
                        </span>
                    )}
                </FormLabel>
                <Field
                    name="id"
                    render={({ field }) => (
                        <NumberField
                            {...field}
                            min={0}
                            customWidth="100%"
                            placeholder="Enter template ID"
                            darkMode={darkMode}
                            readOnly={isEditMode}
                            className={
                                isEditMode
                                    ? 'cursor-default !text-gray-400'
                                    : undefined
                            }
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="The Auto Attendant builder's Template dropdown references this ID. Changing it will point users selecting this template at a different value, so keep it unique."
                        ariaLabel="template-id-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.id}</FieldError>
        </FormControl>
    );
};

export default TemplateIdField;
